module.exports = __webpack_public_path__ + "static/media/poster9.1b4aa644.png";